import React from 'react';
import PropTypes from 'prop-types';

const TeamMemberCard = ({ name, position, imageUrl }) => {
  return (
    <div className="flex flex-col items-center text-center p-4">
      <img
        src={imageUrl}
        alt={`Photo of ${name}`}
        className="w-32 h-40 md:w-36 md:h-44 lg:w-40 lg:h-48 rounded-md object-cover object-top mb-4 shadow-md"
      />
      <h3 className="text-lg font-semibold text-gray-800 mt-2">{name}</h3>
      <p className="text-sm text-gray-600 max-w-64">{position}</p>
    </div>
  );
};

TeamMemberCard.propTypes = {
  name: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

export default TeamMemberCard;
